import { collection, doc, setDoc } from 'firebase/firestore'

import { authState } from '../auth'

import { chatsCollection } from './chats'

const readsCollection = (chatId: string) => collection(chatsCollection(), chatId, 'reads')

export const markAsRead = (chatId: string): Promise<void> => {
  const readRef = doc(readsCollection(chatId), authState.uid)
  return setDoc(readRef, { timestamp: new Date() }, { merge: true })
}
